import { queryOptions } from "@tanstack/react-query";
import { POLL_MS, apiGet, apiPost } from "@amber/ui";
import { bulkJobsResponseSchema } from "@amber/operations/contracts";
import { operationsKeys } from "@amber/operations/ui";
import {
  jobCancelledSchema,
  okResultSchema,
  recoveryPreviewSchema,
  recoveryStartedSchema,
  revisionResultSchema,
  type RecoveryPreviewRequest,
  type RecoveryRequest,
} from "../../contracts/index";
import { collectionKeys } from "./keys";

export const recoveryPreviewQuery = (request: RecoveryPreviewRequest, csrf: string | null) =>
  queryOptions({
    queryKey: collectionKeys.recoveryPreview(request),
    queryFn: () => apiPost("/api/collection/recovery/preview", request, recoveryPreviewSchema, csrf),
    staleTime: 5_000,
  });

export const jobsQuery = queryOptions({
  queryKey: operationsKeys.jobs,
  queryFn: ({ signal }) => apiGet("/api/operations/jobs", bulkJobsResponseSchema, signal),
  refetchInterval: (query) =>
    query.state.data?.jobs.some((j) => j.state === "queued" || j.state === "running") ? 2_000 : POLL_MS,
});

export const recoveryCommands = {
  retry: (id: string, body: { reason: string; base_revision: number }, csrf: string | null) =>
    apiPost(`/api/collection/items/${encodeURIComponent(id)}/retry`, body, revisionResultSchema, csrf),
  stop: (id: string, body: { reason: string; base_revision: number }, csrf: string | null) =>
    apiPost(`/api/collection/items/${encodeURIComponent(id)}/stop-retrying`, body, revisionResultSchema, csrf),
  recover: (body: RecoveryRequest, csrf: string | null) =>
    apiPost("/api/collection/recovery", body, recoveryStartedSchema, csrf),
  cancelJob: (id: string, body: { reason: string }, csrf: string | null) =>
    apiPost(`/api/operations/jobs/${encodeURIComponent(id)}/cancel`, body, jobCancelledSchema, csrf),
  dismissJob: (id: string, csrf: string | null) =>
    apiPost(`/api/operations/jobs/${encodeURIComponent(id)}/dismiss`, {}, okResultSchema, csrf),
};
